export interface IWatrDuplicateCounts {
    watrEmailCount: number,
    watrMobileCount: number
}